import { useDispatch, useReduxState } from 'hooks';
import Router from 'next/router';
import api from 'api';
import { actions } from 'store';
import { ModalButtonWithForm, MoreOptions, Search } from 'components/common';
import { FormGroup, Text } from 'components/common/form';

import { IAdminGroupsUpdate } from './AdminGroups';
import AdminGroupsRemove from './AdminGroupsRemove';

interface Props {
  updateGroups: (obj: IAdminGroupsUpdate) => Promise<void>;
}

const AdminGroupsHeader = ({ updateGroups }: Props) => {
  const { dispatch } = useDispatch();

  const { messages } = useReduxState();

  const handleSubmit = async ({ title }: { title: string }) => {
    try {
      const response = await api.post('/admin/admin-groups', { title });
      await updateGroups({ page: 1, search: '' });
      dispatch(
        actions.addNotice({
          text: messages.adminGroupsAddGroupSuccess,
          type: 'success'
        })
      );
      Router.push(`/admin/admin-groups/${response.data.adminGroup.id}`);
    } catch (err) {
      await dispatch.handleErrorDispatch(err);
    }
  };

  const validateTitle = async (value: string) => {
    if (!value) return messages.commonTitleEmpty;

    try {
      await api.head(`/admin/admin-groups?title=${value}`);
      return messages.commonTitleInUse;
    } catch (err) {
      return undefined;
    }
  };

  return (
    <div className="admin-groups-header">
      <div className="search">
        <Search onSearch={updateGroups} placeholder={messages.groupsSearch} />
      </div>

      <div>
        <ModalButtonWithForm
          buttonIcon="plus"
          buttonSize="header"
          buttonStyle={{ marginRight: 10 }}
          buttonText={messages.adminGroupsAddGroup}
          buttonCategory="success"
          modalActionText={messages.commonSubmit}
          modalTitle={messages.adminGroupsAddGroup}
          onSubmit={handleSubmit}
          pristineIsValid={false}
        >
          {() => (
            <FormGroup label={messages.commonTitle}>
              <Text
                customValidateAsync={validateTitle}
                id="group-title"
                field="title"
              />
            </FormGroup>
          )}
        </ModalButtonWithForm>

        <MoreOptions category="lighter" styleContentButtons={false}>
          <AdminGroupsRemove updateGroups={updateGroups} />
        </MoreOptions>
      </div>

      <style jsx>{`
        .admin-groups-header {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
        }
        .search {
          flex-grow: 1;
          margin-right: 10px;
          max-width: 100%;
          width: 260px;
        }
      `}</style>
    </div>
  );
};

export default AdminGroupsHeader;
